












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class AddVariantFild extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
}
export default AddVariantFild;
